import React from "react";

import BackBreadcrumb from "../BackBreadcrumb";

type PageHeadingProps = {
  title: string;
  superheading?: string;
  subheading?: React.ReactNode;
  children?: React.ReactNode;
  onGoBack?: () => void;
  breadcrumbs?: React.ReactNode;
};
const PageHeading = ({ title, superheading, subheading, children, onGoBack, breadcrumbs }: PageHeadingProps) => {
  return (
    <div className="mb-10 max-w-6xl" data-testid="page-heading">
      {breadcrumbs ||
        (onGoBack && (
          <div className="flex h-6 ">
            <BackBreadcrumb onClick={onGoBack} />
          </div>
        ))}
      <div className="mt-2 md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          {superheading && <div className="text-base font-normal mt-4 mb-2">{superheading}</div>}
          <h2 className="text-3xl font-bold leading-7 text-gray-900">{title}</h2>
          {subheading && <div className="mt-3">{subheading}</div>}
        </div>
        <div className="mt-4 flex-shrink-0 flex items-center space-x-4 md:mt-0 md:ml-4">{children}</div>
      </div>
    </div>
  );
};

export default PageHeading;
